import { useTranslation } from 'react-i18next';

import fetch from '../../../utils/fetcher';
import FormModalContent from '.';
import ServerErrorMessage from '../ServerErrorMessage';

const defaultFormToRequestData = data => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data),
});

// TODO({BEZKGrBHN}): rename, it's not really a hook!
const useCrudModals = (
  openModal,
  {
    entity,
    baseUrl,
    createFormComponent,
    requestToFormData = data => data,
    formToRequestData = defaultFormToRequestData,
    initialValues,
    FormSchema = null,
    afterSuccecss = () => {},
    showConfirmButton = true,
  },
  overrideClassName = null,
) => {
  const { t } = useTranslation(['translation', 'COMMON']);

  const cancelText = t('COMMON.CANCEL');

  const openIt = (callback, params) => {
    openModal(FormModalContent, callback, params, overrideClassName);
  };

  const openDeleteModal = (id, name) => {
    openIt(
      () => new Promise((resolve, reject) => {
        const url = `${baseUrl}/delete/${id}`;
        fetch(url, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
        }).then(() => {
          afterSuccecss();
          return resolve();
        }).catch(reject);
      }),
      {
        title: t('COMMON.DELETE_ENTITY', { entity }),
        message: t('COMMON.DELETE_MESSAGE', { name, entity }),
        showForm: false,
        confirmText: t('COMMON.DELETE'),
        initialValues: {},
        FormSchema: null,
        createFormComponent,
        cancelText,
        showConfirmButton
      },
    );
  };

  const openCreateModal = () => {
    openIt(
      values => new Promise((resolve, reject) => {
        const url = baseUrl;
        fetch(url, formToRequestData(values)).then(() => {
          afterSuccecss();
          return resolve();
        }).catch(reject);
      }),
      {
        title: t('COMMON.CREATE_ENTITY', { entity }),
        confirmText: t('COMMON.CONFIRM'),
        showForm: true,
        initialValues,
        FormSchema,
        createFormComponent,
        showConfirmButton,
        cancelText,
      },
    );
  };

  const openEditModal = id => {
    const request = `${baseUrl}/${id}`;
    fetch(request).then(res => res.json()).then(initialData => {
      const formsInitialData = requestToFormData(initialData);
      openIt(
        values => new Promise((resolve, reject) => {
          const url = `${baseUrl}/${id}`;
          const requestData = formToRequestData(values);

          fetch(url, requestData).then(() => {
            afterSuccecss();
            return resolve();
          }).catch(reject);
        }),
        {
          title: t('COMMON.EDIT_ENTITY', { entity }),
          confirmText: t('COMMON.SAVE'),
          showForm: true,
          initialValues: formsInitialData,
          FormSchema,
          createFormComponent,
          showConfirmButton,
          cancelText,
        },
      );
    }).catch(() => {
      openModal(ServerErrorMessage);
    });
  };

  const openReadModal = id => {
    const request = `${baseUrl}/${id}`;
    fetch(request).then(res => res.json()).then(initialData => {
      const formsInitialData = requestToFormData(initialData);
      openIt(null,
        {
          title: entity,
          showForm: true,
          initialValues: formsInitialData,
          createFormComponent,
          cancelText,
        },
      );
    }).catch(() => {
      openModal(ServerErrorMessage);
    });
  };


  return {
    openReadModal,
    openCreateModal,
    openEditModal,
    openDeleteModal,
  };
};

export default useCrudModals;
